<h1 mat-dialog-title>Select profile</h1>
<div mat-dialog-content >

  <form id="profile">

    <mat-form-field>
      <mat-label>Position</mat-label>

      <mat-select [(value)]="PlayerPositionId"  >
        @for (p of this._positions; track p) {
          <mat-option [value]="p.PlayerPositionId">{{ p.Text }}</mat-option>
        }
      </mat-select>

    </mat-form-field>
    <mat-form-field>
      <mat-label>Profile</mat-label>
      <mat-select [(value)]="profileId"  >
        @for (p of this._profiles; track p) {
          <mat-option [value]="p.ProfileId">{{ p.Name }}</mat-option>
        }
      </mat-select>

    </mat-form-field>
  </form>

</div>
<div mat-dialog-actions>
  <button mat-raised-button color="primary"  (click)="onCloseConfirm()"   cdkFocusInitial>SAVE</button>
  <button mat-button (click)="onNoClick()">CANCEL</button>
</div>
